import axios from 'axios';
import React, { useState, useEffect } from 'react';

import LoadThemeComponent from '../../../base/LoadThemeComponent';
import { isSocialCasino } from '../../../utils/casino';
import { isZambia, isKorsou, isTemplateTheta } from '../../../utils/template';

import Loader from '../../loader/Loader';

import AuthorizedPanel from './AuthorizedPanel';
import AuthorizedPanelDefault from './AuthorizedPanelDefault';
import AuthorizedPanelSocialCasino from './AuthorizedPanelSocialCasino';
import UnauthorizedPanel from './UnauthorizedPanel';
import { renderComponent } from '../../../base/loadComponent';

function UserPanel() {
    const [user, setUser] = useState(null);
    const [links, setLinks] = useState([]);
    const [loading, setLoading] = useState(true);
    const isCasino = window.IS_CASINO || new URLSearchParams(window.location.search).get('isCasino') === '1';
    const url = isCasino ? '/casino/api/internal/user-panel' : '/site/api/user-panel';

    useEffect(() => {
        getUserData();
    }, []);

    function getUserData() {
        axios.get(url).then((response) => {
            setUser(response.data.user);
            setLinks(response.data.links);
            setLoading(false);
        });
    }

    function getUnauthorizedPanel() {
        return <UnauthorizedPanel links={links} />;
    }

    function getAuthorizedPanel() {
        if (isSocialCasino()) {
            return <AuthorizedPanelSocialCasino user={user} links={links} />;
        }

        if (isZambia() || isKorsou() || isTemplateTheta()) {
            return <AuthorizedPanelDefault user={user} links={links} />;
        }

        return <AuthorizedPanel user={user} links={links} />;
    }

    const baseView = () => (
        <div className="row align-items-center justify-content-end text-right flex-nowrap user-panel-wrapper">
            {!user ? getUnauthorizedPanel() : getAuthorizedPanel()}
            {!isSocialCasino() && (
                <button className="navbar-toggler d-xl-none" type="button" data-toggle="collapse" data-target="#menu">
                    <span>
                        <i className="fas fa-bars" />
                    </span>
                </button>
            )}
        </div>
    );

    const defaultView = () => (
        <div className="d-flex align-items-center justify-content-end text-right flex-nowrap user-panel-wrapper">
            {getAuthorizedPanel()}
        </div>
    );

    const getContent = () => {
        return <LoadThemeComponent defaultView={defaultView} baseView={baseView} />;
    };

    return <Loader isLoading={loading} elementToShow={<div className="user-panel">{getContent()}</div>} />;
}

renderComponent(UserPanel, 'user-panel');

export default UserPanel;
